import React from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { BulletinsState } from 'store/modules/bulletins_store/types';
import RegionOverview from 'components/molecules/region_overview';
import EsferaOverview from 'components/molecules/esfera_overview';
import TipoContratacaoOverview from 'components/molecules/tipo_contratacao_overview';
import PortaisOverview from 'components/molecules/portais_overview';
import { Container, SummaryGrid } from './styles';

const OverviewBulletin = () => {
  const { bulletins } = useSelector<ApplicationState, BulletinsState>(
    (state) => state.session.bulletins,
  );
  return (
    <Container>
      <h5 className="my-3">Resumo do Boletim</h5>
      <div className="row">
        <div className="col-md-4 px-3 d-flex">
          <div className="border rounded-lg p-3 w-100">
            <SummaryGrid>
              <div className="summary-row">
                <div className="border rounded-lg p-3 flex-fill d-flex flex-column justify-content-center align-items-center text-center">
                  <p className="mb-1 small">Oportunidades</p>
                  <h1 className="font-weight-bold mb-0">{bulletins?.total}</h1>
                </div>
              </div>
              <div className="summary-row">
                <div className="border rounded-lg p-3 flex-fill d-flex flex-column justify-content-center align-items-center text-center">
                  <p className="mb-1 small">Novas</p>
                  <h1 className="font-weight-bold mb-0">
                    {(bulletins?.by_situation || []).find((s) => s.label === 'NOVA')?.total || 0}
                  </h1>
                </div>
                <div className="border rounded-lg p-3 flex-fill d-flex flex-column justify-content-center align-items-center text-center">
                  <p className="mb-1 small">Urgentes</p>
                  <h1 className="font-weight-bold mb-0">
                    {(bulletins?.by_situation || []).find((s) => s.label === 'URGENTE')?.total || 0}
                  </h1>
                </div>
              </div>
            </SummaryGrid>
          </div>
        </div>
        <div className="col-md-4 px-3 d-flex">
          <div className="border rounded-lg p-3 w-100">
            <RegionOverview data={bulletins?.by_region} />
          </div>
        </div>
        <div className="col-md-4 px-3 d-flex">
          <div className="border rounded-lg p-3 w-100">
            <EsferaOverview data={bulletins?.by_esfera || {}} />
          </div>
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-md-6 px-3 d-flex">
          <div className="border rounded-lg p-3 w-100">
            <TipoContratacaoOverview data={bulletins?.by_modality || []} />
          </div>
        </div>
        <div className="col-md-6 px-3 d-flex">
          <div className="border rounded-lg p-3 w-100">
            <PortaisOverview data={bulletins?.by_portal || []} />
          </div>
        </div>
      </div>
    </Container>
  );
};

export default OverviewBulletin;
